import { defineMessages } from 'react-intl'

export default defineMessages({
  close: {
    id: 'search.close',
    defaultMessage: 'Close',
  },
  title: {
    id: 'search.title',
    defaultMessage: 'Search',
  },
  reset: {
    id: 'search.reset',
    defaultMessage: 'Reset',
  },
  queryPlaceholder: {
    id: 'search.query-placeholder',
    defaultMessage: 'Search events...',
  },
  action: {
    id: 'search.action',
    defaultMessage: 'Search',
  },
})
